import { BaseReactiveClass } from 'Classes/BaseReactiveClass';

export class ModelAccountWalletBeneficialOwnersItem extends BaseReactiveClass {
  static STATUS_INFORMATION_PENDING = undefined;
  static STATUS_RETRY = 'incomplete';
  static STATUS_DOCUMENT = 'document';
  static STATUS_DOCUMENT_PENDING = 'document_pending';
  static STATUS_VERIFIED = 'verified';

  get isStatusRetry() {
    return this.status === ModelAccountWalletBeneficialOwnersItem.STATUS_RETRY;
  }

  get isStatusDocument() {
    return this.status === ModelAccountWalletBeneficialOwnersItem.STATUS_DOCUMENT;
  }

  get isStatusDocumentPending() {
    return this.status === ModelAccountWalletBeneficialOwnersItem.STATUS_DOCUMENT_PENDING;
  }

  get isStatusVerified() {
    return this.status === ModelAccountWalletBeneficialOwnersItem.STATUS_VERIFIED;
  }
}
